import { render, staticRenderFns } from "./Default_Dashboard.vue?vue&type=template&id=159fdc5a&"
import script from "./Default_Dashboard.vue?vue&type=script&lang=js&"
export * from "./Default_Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports